module.exports = __webpack_public_path__ + "img/zalgiris.4c403056.png";